import $ from 'jquery';

export default () => {
    $('.mobile-box').on('click', function () {
        var $mobileLayer = $('#mobile-layer');
        
        var box__image = $(this).find('.mobile-box__image img').attr('src');
        //console.log(box__image);
        
        var box__title = $(this).find('.mobile-box__title').text();
        //console.log(box__title);

        var box__abstract = $(this).find('.mobile-box__abstract').text();
        //console.log(box__abstract);
        
        var box__link = $(this).find('.mobile-box__link').text();
        //console.log(box__link);

        $mobileLayer.find('.mobile-layer__image').attr('src', box__image);
        $mobileLayer.find('.mobile-layer__image').attr('alt', box__title);
        $mobileLayer.find('.mobile-layer__title').text(box__title);
        $mobileLayer.find('.mobile-layer__abstract').text(box__abstract);
        $mobileLayer.find('.mobile-layer__link').attr('href', box__link);
        
        $mobileLayer.fadeIn();
    })
    
    $('.mobile-layer__close').on('click', function() {
        var $mobileLayer = $('#mobile-layer');
        $mobileLayer.fadeOut();
        $mobileLayer.find('.mobile-layer__image').html("");
        $mobileLayer.find('.mobile-layer__title').html("");
        $mobileLayer.find('.mobile-layer__image').attr('alt', '');
        $mobileLayer.find('.mobile-layer__abstract').html("");
        $mobileLayer.find('.mobile-layer__link').attr('href', '');
    })
}


// WEBPACK FOOTER //
// ../views/partials/mobile-layer/mobile-layer.js